import { useState } from 'react'
import { Modal, Button, Checkbox } from '@mantine/core'
import Box from '@/components/ui/Box'
import { receptionItems } from '@/lib/serviceCaseStatuses'

export default function ServiceCaseReceptionItems({ serviceCase, updateServiceCase }) {
    const [opened, setOpened] = useState(false)
    const [selected, setSelected] = useState([])
    const [loading, setLoading] = useState(false)

    const allKeys = Object.keys(receptionItems)
    const currentItems = serviceCase.reception_items || []
    const labels = allKeys
        .filter((key) => currentItems.includes(key))
        .map((key) => receptionItems[key].label)

    const handleOpen = () => {
        setSelected([...currentItems])
        setOpened(true)
    }

    const handleToggle = (key) => {
        setSelected((prev) =>
            prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
        )
    }

    const handleSubmit = async () => {
        setLoading(true)
        const sorted = allKeys.filter((key) => selected.includes(key))
        await updateServiceCase({ reception_items: sorted })
        setLoading(false)
        setOpened(false)
    }

    return (
        <>
            <Box title="Présents à la réception" globalAction={true} action={handleOpen} actionLabel="Modifier la réception">
                {labels.length > 0 ? (
                    <span className="text-sm text-gray-700">{labels.join(', ')}</span>
                ) : (
                    <span className="text-sm text-gray-400">Non renseigné</span>
                )}
            </Box>

            <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                title="Présents à la réception"
                centered
            >
                <div className="flex flex-col gap-3">
                    {Object.entries(receptionItems).map(([key, { label }]) => (
                        <Checkbox
                            key={key}
                            label={label}
                            checked={selected.includes(key)}
                            onChange={() => handleToggle(key)}
                        />
                    ))}

                    <Button fullWidth mt="sm" onClick={handleSubmit} loading={loading}>
                        Enregistrer
                    </Button>
                </div>
            </Modal>
        </>
    )
}
